exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ag-pre-table .ag-header-cell-label{justify-content:center!important}.slide-custom-enter{transform:translateX(30vw)}.slide-custom-enter-active,.slide-custom-leave-active{transition:all .3s ease-in}.slide-custom-leave-to,.slide-custom-two-enter{transform:translateX(30vw)}.slide-custom-two-enter-active,.slide-custom-two-leave-active{transition:all .3s ease-in}.slide-custom-two-leave-to{transform:translateX(30vw)}.process .tag-process{margin-right:5px;height:auto!important;font-size:17px!important;padding-left:.35em!important;padding-right:.35em!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7a3b8f84","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lideres/Proceso.vue
// module id = 1139
// module chunks = 2